import { NotificationUserQuestion } from "src/components/Main/News/Forum/UserQuestion/UserQuestion";
import { Modal } from "src/components/Modals/Components/ModalsComponents";

interface ForumQuestionAnswerModalProps {
	parentId: string;
	onClose: () => void;
}

export const ForumQuestionAnswerModal = ({
	parentId,
	onClose,
}: ForumQuestionAnswerModalProps) => {
	return (
		<Modal open onClose={onClose}>
			<NotificationUserQuestion parentId={parentId} />
		</Modal>
	);
};
